/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Avatar, Typography } from 'components'
import getImageUrl from 'utils/getImageUrl'
import { getFullName } from 'utils/utils'
import _ from 'lodash'
import { ReactComponent as EmptyStarIcon } from 'images/EmptyStar.svg'
import { ReactComponent as FullStarIcon } from 'images/FullStar.svg'
import { ReactComponent as RightIcon } from 'images/ArrowRightWhite.svg'
import Button from '../../components/button'
import moment from 'moment'

const MyButton = styled((props) => <Button {...props} />)`
  box-shadow: none;
  color: ${({ color, theme }) => color || theme.primary1};
  padding: 0px;
  /*border: ${({ border, theme }) => border || `1px solid ${theme.gray2}`};*/
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize}px;
  /*svg {
    fill: ${({ color, theme }) => color || theme.gray2};
    width: ${({ iconSize }) => `${iconSize}px`};
    height: ${({ iconSize }) => `${iconSize}px`};
  }*/
`

const Container = styled.div`
  width: 100%;
  margin-top: 20px;
`
const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`
const ItemContent = styled.div`
  display: flex;
  align-items: ${({ alignItem }) => alignItem};
  flex-direction: row;
  border-bottom: 0.5px solid ${({ theme }) => theme.dark};
  gap: 13px;
  padding-bottom: 15px;

  :last-child {
    border-bottom: none;
  }
`
const ItemDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const StarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 4px 0px;
`
const LinkContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`
const LinkGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  :hover {
    p {
      text-decoration: underline;
      color: ${({ theme }) => theme['sa-blue']};
    }
  }
`

const avatarSize = 52
const imageSize = avatarSize * 2
const starSize = 11

const Item = ({ data, locale }) => {
  const [showAll, setShowAll] = useState(false)
  const createdTimes = moment(data?.createdAt)
    .locale(locale === 'en' ? 'en' : 'th')
    .fromNow()
  return (
    <ErrorBoundary>
      <ItemContent alignItem={data?.comment === '' ? 'center' : 'flex-start'}>
        <Avatar
          noneBorder
          width={avatarSize}
          src={getImageUrl(
            data?.appUser.profileImage,
            `https://via.placeholder.com/${imageSize}`,
            imageSize,
            imageSize
          )}
          //margin="6px 0 0 0"
        />
        <ItemDetail>
          <div
            style={{
              display: 'flex',
              justifyContent: data?.comment === '' ? 'center' : 'space-between',
            }}
          >
            <div style={{ display: 'flex', width: '100%' }}>
              <Typography color="primary1" fontSize="text-base" lineHeight="20px">
                {getFullName(data?.appUser)}
              </Typography>
              <Typography fontSize="text-xs" margin={'0px 5px 0px 5px'} color="black">
                •
              </Typography>
              <Typography fontSize="text-xs" margin={'0px'} color="black60" width="50%">
                {createdTimes}
              </Typography>
            </div>
            <StarGroup>
              {_.times(5, (index) => {
                if (index < data?.rating) {
                  return <FullStarIcon width={starSize} height={starSize} />
                }
                return <EmptyStarIcon width={starSize} height={starSize} />
              })}
            </StarGroup>
          </div>
          <Typography
            fontSize="text-sm"
            lineHeight="20px"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: showAll ? 'inherit' : 3,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {data?.comment}
          </Typography>
          {data?.comment.length > 370 && (
            <MyButton
              id={showAll ? 'button.editor.showLess' : 'button.editor.showMore'}
              reverse
              bgColor="transparent"
              fontSize="12"
              onClick={() => setShowAll((prev) => !prev)}
              style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
            >
              {showAll ? 'See less' : 'See more'}
            </MyButton>
          )}
        </ItemDetail>
      </ItemContent>
    </ErrorBoundary>
  )
}

const ReviewTab = (props) => {
  const {
    courseId,
    courseReviews,
    getCourseReviews,
    courseReviewsCount,
    getCourseReviewsCount,
    locale,
  } = props
  const location = useLocation()

  useEffect(() => {
    if (courseId) {
      getCourseReviews({ courseId, limit: 5 })
      getCourseReviewsCount({ courseId })
    }
  }, [courseId])

  return (
    <ErrorBoundary>
      <Container>
        <ListContainer>
          {courseReviews.map((item, index) => {
            return <Item key={index} data={item} locale={locale} />
          })}
        </ListContainer>
        {courseReviewsCount > 5 && (
          <LinkContainer>
            <Link to={`${location.pathname}/reviews`}>
              <LinkGroup>
                <Typography id="reviewList.seeAll" color="white" lineHeight="22px">
                  See all
                </Typography>
                <RightIcon width={8} height={16} />
              </LinkGroup>
            </Link>
          </LinkContainer>
        )}
      </Container>
    </ErrorBoundary>
  )
}

const mapState = (state) => ({
  courseReviews: state.Course.courseReviews,
  courseReviewsCount: state.Course.courseReviewsCount,
  locale: state.Language.locale,
})
const mapDispatch = (dispatch) => ({
  getCourseReviews: dispatch.Course.getCourseReviews,
  getCourseReviewsCount: dispatch.Course.getCourseReviewsCount,
})

export default connect(mapState, mapDispatch)(ReviewTab)
